import { SanityImageAssetDocument } from "@sanity/client";
import Image from "../media/image";

export type AdEntry = {
  adLink: string;
  image: {
    asset: SanityImageAssetDocument;
    alt?: string;
  };
  squareImage: {
    asset: SanityImageAssetDocument;
    alt?: string;
  };
};

const DAY_MS = 86_400_000;

// Deterministisk valg av annonse: seed gir variasjon mellom plasseringer,
// dagsbucket gir rotasjon over tid. Math.random() i render ville brutt
// hydration siden server og klient ville plukket ulik indeks.
function pickAd(ads: AdEntry[], seed: number): AdEntry {
  const dayBucket = Math.floor(Date.now() / DAY_MS);
  return ads[(Math.abs(seed) + dayBucket) % ads.length];
}

export const PickAndDisplayAd = ({
  className = "c-advertisement",
  wide = true,
  ads,
  seed = 0,
}: {
  className?: string;
  ads: AdEntry[];
  wide?: boolean;
  seed?: number;
}) => {
  const ad = pickAd(ads, seed);
  const imageToDisplay = wide || !ad.squareImage ? ad.image : ad.squareImage;

  return (
    <a className={`${className} u-block`} href={ad.adLink || ""}>
      <p className="c-advertisement-card__tag">Annonse</p>
      {imageToDisplay && (
        <Image
          image={imageToDisplay.asset}
          className="u-max-width-full"
          alt={imageToDisplay.alt || ""}
          interceptBuilder={builder => builder.width(600)}
        />
      )}
    </a>
  );
};
